import decodeJwt from 'jwt-decode';
import { properties as propertiesCloudConfig } from '../config/Config';
import axios from 'axios';
import queryString from 'query-string';
import {localStorageName} from './localStorageData';
import { useContext} from 'react';
import AppContext from 'AppContext';
import { properties } from 'AppData';
import lodash from 'lodash';

const AuthProvider = () => {
    const contexto = useContext(AppContext);

    // called when the user attempts to log in
    const login = async (user, pass, refreshToken) => {
        // Obteniendo los datos necesarios de Keycloak
        var token = localStorage.getItem(localStorageName.token);
        localStorage.setItem(localStorageName.token, localStorageName.obteniendo_token);
        await checkCloudProperties(100);        
        const token_url = propertiesCloudConfig['KEYCLOAK_IP_ADDRESS'] + propertiesCloudConfig['KEYCLOAK_API_TOKEN'];
        var client_id;
        var client_secret;        
        var username;
        var password;
        var refresh_token;
        var oAuthParams;

        if(user === 'ciudadano'){
            user = propertiesCloudConfig['KEYCLOAK_AUTH_CIUDADANO_USERNAME'];
        }else if (!user || user === 'aplicacion') {         
            user = propertiesCloudConfig['KEYCLOAK_AUTH_APLICACION_USERNAME'];
        }

        if(user === propertiesCloudConfig['KEYCLOAK_AUTH_APLICACION_USERNAME']) {
            client_id = propertiesCloudConfig['KEYCLOAK_AUTH_APLICACION_CLIENT_ID'];
            client_secret = propertiesCloudConfig['KEYCLOAK_AUTH_APLICACION_CLIENT_SECRET'];        
            username = propertiesCloudConfig['KEYCLOAK_AUTH_APLICACION_USERNAME'];
            password = propertiesCloudConfig['KEYCLOAK_AUTH_APLICACION_PASSWORD'];
        }else if(user === propertiesCloudConfig['KEYCLOAK_AUTH_CIUDADANO_USERNAME']){
            client_id = propertiesCloudConfig['KEYCLOAK_AUTH_CIUDADANO_CLIENT_ID'];
            client_secret = propertiesCloudConfig['KEYCLOAK_AUTH_CIUDADANO_CLIENT_SECRET']; 
            username = propertiesCloudConfig['KEYCLOAK_AUTH_CIUDADANO_USERNAME'];
            password = propertiesCloudConfig['KEYCLOAK_AUTH_CIUDADANO_PASSWORD'];
        }else{
            client_id = propertiesCloudConfig['KEYCLOAK_AUTH_CIUDADANO_CLIENT_ID'];
            client_secret = propertiesCloudConfig['KEYCLOAK_AUTH_CIUDADANO_CLIENT_SECRET']; 
            username = user;
            password = pass;
        }

        if(refreshToken){
            refresh_token = localStorage.getItem(localStorageName.refresh_token);

            oAuthParams = {
                grant_type: "refresh_token",
                client_id,
                client_secret,
                username,
                password,
                refresh_token,
            }
        }else{        
            oAuthParams = {
                grant_type: "password",
                client_id,
                client_secret,
                username,
                password,
            }        
        }

        return axios.post(token_url, queryString.stringify(oAuthParams), { headers: {'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'} })
        .then(({ data }) => {
            localStorage.setItem(localStorageName.username, username);
            
            localStorage.setItem(localStorageName.token, data.access_token);
            const decodedToken = decodeJwt(data.access_token);
            localStorage.setItem(localStorageName.expiredTime, decodedToken.exp);
            
            localStorage.setItem(localStorageName.refresh_token, data.refresh_token);
            const decodedRefreshToken = decodeJwt(data.refresh_token);
            localStorage.setItem(localStorageName.expiredTimeRefresh, decodedRefreshToken.exp);

            const permissions = lodash.get(decodedToken, `resource_access[${client_id}].roles`, null);
            localStorage.setItem(localStorageName.permissions, permissions);

        }).catch(error => {
            if(username === propertiesCloudConfig['KEYCLOAK_AUTH_APLICACION_USERNAME']){
                logout();
            }else{
                localStorage.setItem(localStorageName.token, token);
            }
                        
            let respuesta = {
                response: {
                  status: "401",
                  data: {
                    messageDescription: "No Autorizado"
                    }
                }
            };                
            return Promise.reject(respuesta);
        });
    };

    // called when the user clicks on the logout button
    const logout = () => {
        localStorage.removeItem(localStorageName.username);
        localStorage.removeItem(localStorageName.token);
        localStorage.removeItem(localStorageName.refresh_token);        
        localStorage.removeItem(localStorageName.expiredTimeRefresh);
        localStorage.removeItem(localStorageName.permissions);
        localStorage.removeItem(localStorageName.credencialGuardada);
        //return Promise.resolve();
    };
    // called when the API returns an error
    const checkError = ({ status }) => {
        if (status === 401) {
            logout();
            return Promise.reject();
        } else if (status === 403) {
            return Promise.reject();
        }
        return Promise.resolve();
    };
    // called when the user navigates to a new location, to check for authentication
    const checkTokenTime = (refreshToken) => {
        let lifespan;
        let notExpired;

        if(refreshToken){
            lifespan = localStorage.getItem(localStorageName.expiredTimeRefresh) > (Date.now()/1000);
            notExpired = localStorage.getItem(localStorageName.refresh_token) && lifespan;
        }else{
            lifespan = localStorage.getItem(localStorageName.expiredTime) > (Date.now()/1000);
            notExpired = localStorage.getItem(localStorageName.token) && lifespan;
        }

        return notExpired;
    };
    // called when the user navigates to a new location, to check for permissions / roles
    const getPermissions = () => { 
        return localStorage.getItem('permissions');
        //return role ? Promise.resolve(role) : Promise.reject();
    };

    const getToken = async () => {
        //1. Comprobación y espera hasta que las propiedades del cloud-config esten cargadas
        await checkCloudProperties(100);
        let verificarTokenTime = 100;
        let access_token = localStorage.getItem(localStorageName.token);
        var username = localStorage.getItem(localStorageName.username);
        var notExpired = true;
        
        //2. Verificación de la expiración del access_token
        if (!username) {         
            username = propertiesCloudConfig['KEYCLOAK_AUTH_APLICACION_USERNAME'];
        }else{
            notExpired = await checkTokenTime(false);
        }

        //3. Si no se está obteniendo el token y el access_token ha expirado,
        //se comprueba la expiración del refresh_token
        if (access_token !== localStorageName.obteniendo_token && !notExpired) {
            notExpired = await checkTokenTime(true);
            //4. Si el refresh_token no ha expirado se refresca el access_token
            if(notExpired){                
                await login(username, '', true);
                access_token = localStorage.getItem(localStorageName.token);            
            }else{
                //5. Si el refresh_token ha expirado y el usuario es aplicacion, se solicita un nuevo access_token
                if(username === propertiesCloudConfig['KEYCLOAK_AUTH_APLICACION_USERNAME']){
                    await login(propertiesCloudConfig['KEYCLOAK_AUTH_APLICACION_USERNAME'], '', false);
                    access_token = localStorage.getItem(localStorageName.token);
                }else {
                    //6. Si el refresh_token ha expirado y el usuario es ciudadano, se cierra sesión
                    logout();
                    contexto.updateSesion(properties.SESION_CADUCADA)
                    let respuesta = {
                        response: {
                          status: "401",
                          data: {
                            messageDescription: "No Autorizado"
                            }
                        }
                    };                
                    return Promise.reject(respuesta);
                }                    
            }
        } else {
            //6. Se solicita un access_token, en caso de que ya se este solicitando uno se pone a la espera las request
            if (access_token) {
                if (access_token === localStorageName.obteniendo_token) {
                    await checkToken(verificarTokenTime);
                    access_token = localStorage.getItem(localStorageName.token);
                }
            } else {                
                await login(propertiesCloudConfig['KEYCLOAK_AUTH_APLICACION_USERNAME'], '', false);
                access_token = localStorage.getItem(localStorageName.token);            
            }
        }
        return access_token;
    };    

    const checkToken = (ms) => {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                let access_token = localStorage.getItem(localStorageName.token);
                if (access_token === localStorageName.obteniendo_token) {
                    resolve(checkToken(ms));
                }else{
                    resolve();
                }
            }, ms);
        });
    };

    const checkCloudProperties = (ms) => {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                let server = propertiesCloudConfig['KEYCLOAK_IP_ADDRESS'];
                if (typeof server === 'undefined') {
                    resolve(checkCloudProperties(ms));
                }else{
                    resolve();
                }
            }, ms);
        });
    };
    return {getToken, login, logout, checkError, getPermissions, checkCloudProperties};
}
export default AuthProvider;